import { Box, Flex, Text } from "@chakra-ui/react"
import Table from "components/UI/organisms/Table"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { useReportsContext } from "providers/ReportsProvider/ReportsProvider"
import { IReportPreview } from "providers/ReportsProvider/ReportsProviderTypes"
import { useUI } from "providers/UIProvider"
import { IRoles } from "types/shared"


const ExcelTable = () => {

    const { reportPreview } = useReportsContext()
    const { userRole } = useAppContext()
    const { T } = useUI()

    const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole);


    const totalServiceAmount = reportPreview?.reduce((sum, item) => sum + (item.serviceAmount || 0), 0);
    const totalWasherSalaryAmount = reportPreview?.reduce((sum, item) => sum + (item.washerSalary || 0), 0);
    const totalReturnAmount = reportPreview?.reduce((sum, item) => sum + (item.returnedAmount || 0), 0);
    const totalAmountAfterDiscount = reportPreview?.reduce((sum, item) => sum + (item.amountAfterDiscount || 0), 0);



    const getColumns = (isQappUser: boolean | null, T: any) => {
        const columns = [
            {
                key: "customer_id",
                label: T("excel.customer_id"),
                render: (data: IReportPreview) => (
                    <Flex style={{ justifyContent: "center", alignItems: "center", height: "5px" }}>
                        <Text fontWeight="bold">{data?.customerId ?? "---"}</Text>
                    </Flex>
                ),
            },
            isQappUser && {
                key: "customer_fullname",
                label: T("excel.customer_fullname"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.customerFullName ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "customer_mobile",
                label: T("excel.customer_mobile"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.customerMobile === "" ? "---" : data?.customerMobile}</Text>
                    </Flex>
                ),
            },
            {
                key: "vehicle_govNumber",
                label: T("excel.vehicle_govNumber"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.vehicleGovNumber ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "vehicle_bodyType",
                label: T("excel.vehicle_bodyType"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.vehicleBodyType ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "vehicle_mark",
                label: T("excel.vehicle_mark"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.vehicleMark ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "vehicle_model",
                label: T("excel.vehicle_model"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.vehicleModel ?? "---"}</Text>
                    </Flex>
                ),
            },
            isQappUser && {
                key: "carWash_ID",
                label: T("excel.carWash_ID"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.carWashId ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "carWash_name",
                label: T("excel.carWash_name"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                        }} fontWeight="bold">{data?.carWashName ?? "---"}</Text>
                    </Flex>
                ),
            },
            isQappUser && {
                key: "carWash_contact_number",
                label: T("excel.carWash_contact_number"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.carWashContactNumber ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "carWash_address",
                label: T("excel.carWash_address"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.carWashAddress ?? "---"}</Text>
                    </Flex>
                ),
            },
            isQappUser && {
                key: "bank_account",
                label: T("excel.bank_account"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.bankAccount ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "service_name",
                label: T("excel.service_name"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.serviceName ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "service_amount",
                label: <Box>{T("excel.service_amount")}<Text style={{ color: "#a10000" }}>{`(${totalServiceAmount ? totalServiceAmount?.toFixed(2) : "---"})`}</Text></Box>,
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.serviceAmount ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "washer_salary",
                label: <Box>{T("excel.washer_salary")}<Text style={{ color: "#a10000" }}>{`(${totalWasherSalaryAmount ? totalWasherSalaryAmount?.toFixed(2) : "---"})`}</Text></Box>,
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.washerSalary ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "discount_percent",
                label: T("excel.discount_percent"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.discountPercent ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "amount_after_discount",
                label: <Box>{T("excel.amount_after_discount")}<Text style={{ color: "#a10000" }}>{`(${totalAmountAfterDiscount ? totalAmountAfterDiscount?.toFixed(2) : "---"})`}</Text></Box>,
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.amountAfterDiscount ?? "---"}</Text>
                    </Flex>
                ),
            },
            isQappUser && {
                key: "carWash_amount",
                label: T("excel.carWash_amount"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.carWashAmount ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "returned_amount",
                label: <Box>{T("excel.returned_amount")}<Text style={{ color: "#a10000" }}>{`(${totalReturnAmount ? totalReturnAmount?.toFixed(2) : "---"})`}</Text></Box>,
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.returnedAmount ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "discount_type",
                label: T("excel.discount_type"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.discountType ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "reserved_date",
                label: T("excel.reserved_date"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservedDate ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "reserved_time",
                label: T("excel.reserved_time"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservedTime ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "reservation_start_date",
                label: T("excel.reservation_start_date"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservationStartDate ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "reservation_start_time",
                label: T("excel.reservation_start_time"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservationStartTime ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "reservation_end_date",
                label: T("excel.reservation_end_date"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservationEndDate ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "reservation_end_time",
                label: T("excel.reservation_end_time"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservationEndTime ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "box",
                label: T("excel.box"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.box ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "washer",
                label: T("excel.washer"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                        }} fontWeight="bold">{data?.washer ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "bank",
                label: T("excel.bank"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.bank ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "transaction_status",
                label: T("excel.transaction_status"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.transStatus ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "real.start.date",
                label: T("excel.real.start.date"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservationRealStartDate ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "real_start_time",
                label: T("excel.real_start_time"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservationRealStartTime ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "end_real_date",
                label: T("excel.end_real_date"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservationRealEndDate ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "real.end.time",
                label: T("excel.real.end.time"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text fontWeight="bold">{data?.reservationRealEndTime ?? "---"}</Text>
                    </Flex>
                ),
            },
            {
                key: "status.of.reservation",
                label: T("excel.status.of.reservation"),
                render: (data: IReportPreview) => (

                    <Flex style={{ justifyContent: "center", alignItems: "center" }}>
                        <Text style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                        }} fontWeight="bold">{data?.reservationStatus ?? "---"}</Text>
                    </Flex>
                ),
            },
        ]
        return columns.filter(Boolean)
    }


    const columns = getColumns(isQappUser, T)



    return (
        <Flex style={{ height: "400px", width: "105%", marginTop: "30px" }}>
            <Table
                T={T}
                isReportsPage={true}
                overflow="scroll"
                topBorderRadius={false}
                data={reportPreview ? reportPreview : []}
                columns={columns}
            />
        </Flex>
    )
}

export default ExcelTable